import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import React from 'react'

export const RelogioPonto: React.FC = () => {
    return (
        <section id="relogio-ponto">
            <HorizontalDivider className="mb-4 mt-6">
                Relógio de ponto / Aplicativo coletivo
            </HorizontalDivider>
            <Grid container columns={24}>
                <Grid item xs={12}>
                    <FormField name="repCodigo" label="Cód/Matrícula" />
                </Grid>
                <Grid item xs={12}>
                    <FormField name="repProximidade" label="Proximidade/RFID" />
                </Grid>
                <Grid item xs={12}>
                    <FormField name="repCodBarras" label="Código de barras" />
                </Grid>
                <Grid item xs={12}>
                    <FormField name="repSenha" label="Senha" />
                </Grid>
                <Grid item xs={12}>
                    <FormFieldCheckbox
                        name="repSupervisor"
                        label="Supervisor"
                    />
                </Grid>
            </Grid>
        </section>
    )
}
